// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__NyZ0n"};